<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-user-alt"></i>
        탈퇴 목록
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">관리</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">탈퇴</a>
        </li>
      </ul>
    </div>
    <!--//-------------------------------------------------------------------------검색조건-->
    <!-- detail search start -->
    <b-card v-show="so.adv">
      <b-row>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="opt_date">날짜</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
          <b-form-group>
            <b-button class="mb-2 ml-1" size="sm" variant="outline-primary" @click="set_sd('')"><i class="fa fa-remove"></i></b-button>
            <b-button class="mb-2" size="sm" variant="primary" @click="set_sd('-1d')">-1일</b-button>
            <b-button class="mb-2" size="sm" variant="primary" @click="set_sd('-1w')">-1주</b-button>
            <b-button class="mb-2" size="sm" variant="primary" @click="set_sd('-1m')">-1달</b-button>
            <b-button class="mb-2" size="sm" variant="primary" @click="set_sd('w')">1주</b-button>
            <b-button class="mb-2" size="sm" variant="primary" @click="set_sd('m')">1달</b-button>
            <b-form inline class="mt-2">
              <date-picker @change="refresh" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
              ~
              <date-picker @change="refresh" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
              <!-- <b-button inline class="m-1" variant="warning" @click="so.opt['created_at_ed'] = ''; so.opt['created_at_sd'] = ''; refresh()">Clear</b-button> -->
            </b-form>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="opt_description">설명</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center mt-3">
          <b-form-group>
            <b-input v-model="so.opt['description']" @keyup.enter="refresh"></b-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="ph_search_group">회사명</label>
        </b-col>
        <b-col v-if="group_name" class="col-xl-3 col-md-12 align-self-center">
          <b-form-group>
            <b-form-input @keydown.enter="refresh" type="text" :disabled="false" v-model="group_name"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col v-if="group_name" class="col-xl-1 col-md-12 align-self-center">
          <b-form-group>
            <b-button size="sm" id="ph_clear_group" variant="warning" @click="clearChain('group')">초기화</b-button>
          </b-form-group>
        </b-col>
        <b-col v-if="!group_name " class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <b-button size="sm" id="ph_search_group" :variant="group_name ? 'primary' : 'add'" @click="chainGroup = true">그룹 선택</b-button>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="ph_search_partner">파트너 이름</label>
        </b-col>
        <b-col v-if="partner_name" class="col-xl-3 col-md-12 align-self-center">
          <b-form-group>
            <b-form-input @keydown.enter="refresh" type="text" :disabled="false" v-model="partner_name"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col v-if="partner_name" class="col-xl-1 col-md-12 align-self-center">
          <b-form-group>
            <b-button size="sm" id="ph_clear_partner" variant="warning" @click="clearChain('partner')">초기화</b-button>
          </b-form-group>
        </b-col>
        <b-col v-if="!partner_name" class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <b-button size="sm" id="ph_search_partner" :variant="partner_name ? 'primary' : 'add'" @click="chainPartner = true">파트너 선택</b-button>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="col-xl-1 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="ph_search_opt_type">완료</label>
        </b-col>
        <b-col class="col-xl-1 col-md-12 d-flex align-self-center mt-4">
          <b-form-group>
            <div class="checkbox-switch">
              <input type="checkbox" class="input-checkbox" name="switch06" id="switch06" label size="sm" v-model="so.opt['is_del']" @change="refresh">
              <div class="checkbox-animate disabled">
                <span class="checkbox-off">OFF</span>
                <span class="checkbox-on">ON</span>
              </div>
            </div>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-1 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="ph_search_opt_type">복구</label>
        </b-col>
        <b-col class="col-xl-1 col-md-12 d-flex align-self-center mt-4">
          <b-form-group>
            <div class="checkbox-switch">
              <input type="checkbox" class="input-checkbox" name="switch06" id="switch06" label size="sm" v-model="so.opt['is_recovery']" @change="refresh">
              <div class="checkbox-animate disabled">
                <span class="checkbox-off">OFF</span>
                <span class="checkbox-on">ON</span>
              </div>
            </div>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-1 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="ph_search_opt_type">승인</label>
        </b-col>
        <b-col class="col-xl-1 col-md-12 d-flex align-self-center mt-4">
          <b-form-group>
            <div class="checkbox-switch">
              <input type="checkbox" class="input-checkbox" name="switch06" id="switch06" label size="sm" v-model="so.opt['is_approve']" @change="refresh">
              <div class="checkbox-animate disabled">
                <span class="checkbox-off">OFF</span>
                <span class="checkbox-on">ON</span>
              </div>
            </div>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-mb-12 d-flex align-self-center">
          <label class="col-form-label" for="ph_search_opt_type">일치 유형</label>
        </b-col>
        <b-col class="col-xl-4 col-mb-12 d-flex align-self-center mt-4">
          <b-form-group>
            <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" @change="refresh" name="ph_search_opt_type">
              <b-form-radio value="and">모두 일치</b-form-radio>
              <b-form-radio value="or">최소 한개 이상 일치</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="float-right mt-3">
        <b-form-group>
          <b-button size="sm" variant="add" @click="refresh"> 찾기 </b-button>
          <b-button size="sm" variant="warning" @click="reset"> 초기화 </b-button>
          <b-button size="sm" variant="secondary" @click="search_opt"> 닫기 </b-button>
        </b-form-group>
      </b-row>
    </b-card>
    <!-- detail search end -->
    <div class="d-flex flex-wrap align-items-center">
      <b-col sm="2">
        <span class="badge badge_border_primary mb-2">전체 : <span style="padding-left: 1rem"></span>{{model.total.toString().padStart(3, nbsp) || 0 | number}}</span>
        <br>
        <span class="badge badge_border_info mb-2">대기 :  <span style="padding-left: 1rem"></span>{{model.enable.toString().padStart(3, nbsp) || 0 | number}}</span>
        <br>
        <span class="badge badge_border_warning mb-2">완료 : <span style="padding-left: 1rem"></span>{{model.disable.toString().padStart(3, nbsp) || 0 | number}}</span>
      </b-col>
      
      <b-col class="md-10 d-flex flex-wrap align-items-center">
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
          <div class="mr-2 mb7 mt-2">
            <button class="btn btn-icon mr-1" @click="refresh()">
              <i class="fas fa-sync-alt"></i>
            </button>
            <button class="btn btn-icon mr-1" @click="reset()">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="mr-2 mb7">
            <select class="form-control" name="sel1" id="sel1" :disabled="so.adv" :text="so.skt || '찾기'" v-model="so.sk" @change="sv_reset">
              <option disabled value="">검색</option>
              <option value="partner.username">파트너</option>
              <option value="group.groupname">회사</option>
              <!-- <option value="description">설명</option> -->
            </select>
          </div>
          <div class="mr-2 mb7">
            <input type="text" class="form-control col-xl-12" name="input" id="input" v-model="so.sv" @keyup.enter="refresh()">
          </div>
          <div class="mb7">
            <button class="btn btn-icon1 mr-1 mt-1" @click="refresh()">
              <i class="fas fa-search"></i>
            </button>
            <!-- <button class="btn btn-icon2" @click="search_opt">
              <i class="fas fa-search-plus" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i>
            </button> -->
          </div>
        </b-input-group>
        <br>
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
          <div class="mt-2">
            <b-checkbox @change="refresh" class="ml-3 mt-1" v-model="hide_del">삭제된 항목 숨기기</b-checkbox>
          </div>
          <div class="mb7">
            <select class="form-control" name="sel2" id="sel2" v-model="so.perPage" @change="refresh">
              <option disabled value="15">표시되는 개수 : 기본 15개</option>
              <option value=10>10</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>
          </div>
        </b-input-group>
      </b-col>
    </div>
    <!--//-------------------------------------------------------------------------검색조건-->
    <!--//-------------------------------------------------------------------------리스트출력-->
    <div class="reg_card">
      <div class="reg_card_body">
        <div class="table-responsive">
        <b-table class="table table_add table-striped" hover striped responsive="sm" ref="_list" show-empty empty-text="관련된 정보가 없어요."
          :items="load" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk" @row-clicked="goDetail" style="cursor:pointer;">
          <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
          <template slot="created_at" slot-scope="row">{{row.item.created_at | sdate }}</template>
          <template slot="is_del" slot-scope="row">
            <b-badge :variant="row.item.is_del ? 'success' : 'secondary'">{{row.item.is_del ? '완료' : '대기'}}</b-badge>
          </template>
          <template slot="partner" slot-scope="row">
            {{row.item.partner.username || '-'}}
          </template>
          <template slot="group" slot-scope="row">
            {{row.item.group.groupname || '-'}}
          </template>
          <template slot="is_recovery" slot-scope="row">
            <b-badge :variant="row.item.is_recovery ? 'success' : 'secondary'">{{row.item.is_recovery ? 'On' : 'Off'}}</b-badge>
          </template>
          <template slot="is_approve" slot-scope="row">
            <b-badge :variant="row.item.is_approve ? 'success' : 'secondary'">{{row.item.is_approve ? 'On' : 'Off'}}</b-badge>
          </template>
        </b-table>
        </div>
      </div>
    </div>
    <!--//-------------------------------------------------------------------------리스트출력-->
    <!--//-------------------------------------------------------------------------Pagination-->
    <div class="mt30">
      <b-pagination class="pagination justify-content-center" size="sm" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage" :limit="10" prev-text="<" next-text=">"  />
    </div>
    <!--//-------------------------------------------------------------------------Pagination-->
    <!-- start modal -->
    <b-modal title="Find then Group and Select" size="xl" v-model="chainGroup" @ok="chainGroup = false" ok-only cancel-variant="info">
      <group-List :auto_refresh="false" :enable_new="false" :view_detail="false" @select="setGroup"></group-List>
    </b-modal>
    <!-- start modal -->
    <b-modal title="Find then Partner and Select" size="xl" v-model="chainPartner" @ok="chainPartner = false" ok-only cancel-variant="info">
      <partner-List :auto_refresh="false" :enable_new="false" :view_detail="false" @select="setPartner"></partner-List>
    </b-modal>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>